export const get = (url, failOnError = false) =>
  fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }).then(response => {
    if (failOnError && !response.ok) {
      throw new Error('Api Error')
    }
    return response.json()
  })
